import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

const Footer = () => {
    return (
        <React.Fragment>
            <Grid
                container
                justifyContent="center"
                sx={{
                    background: "#c7baaa3a",
                    minHeight: "10rem",
                    pt: 1,
                    pb: 1,
                }}
            >
                <Divider />
                <Container style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <img src="/images/Logo/logo.png" width="60%" />
                </Container>
            </Grid>
        </React.Fragment>
    );
};

export default Footer;
